// Burbuja con el nombre de una financiera y su color; la que el portal no conoce va neutra.
import { cn } from '@/lib/cn';
import { financierName } from '@/domains/credit/origination/lib/originationMetrics';

const FINANCIER_TONE: Record<string, string> = {
    SUREKEEP: 'bg-success-soft text-success',
    PAYJOY: 'bg-info-soft text-info',
    CREDIYA: 'bg-warning-soft text-warning',
    KREDIYA: 'bg-warning-soft text-warning',
};
const NEUTRAL_TONE = 'bg-muted text-muted-foreground';

export function FinancierBadge({ code }: { code: string }) {
    return (
        <span
            className={cn(
                'whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold',
                FINANCIER_TONE[code] ?? NEUTRAL_TONE,
            )}
        >
            {financierName(code)}
        </span>
    );
}
